import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, filter, switchMap, take, throwError } from 'rxjs';
import { LoggerService } from '../shared/logger.service';
import { Router } from '@angular/router';
import { AuthTokenService } from '../auth/auth-token.service';
import { AuthService } from '../auth/auth.service';

let isRefreshing = false;

export const refresherInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(LoggerService);
  let authTokenService = inject(AuthTokenService);
  let authService = inject(AuthService);
  let router = inject(Router);

  const bearerToken = authTokenService.tokenComputed(); //.tokenUser;
  // logger.debug(`refresherInterceptor:token: `, bearerToken);
  if (bearerToken && bearerToken !== 'undefined') {
    const clonedReq = req.clone({
      withCredentials: true,
      headers: req.headers.append('Authorization', `Bearer ${bearerToken}`),
    })

    return next(clonedReq)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          logger.error(`catchError: `, error);
          if (error.status === 401 || error.status === 403) {
            return handle401Error(req, next, authService, authTokenService, logger, router);
          }
          return throwError(() => error);
        })
      );
  } else {
    return next(req);
  }
};

function handle401Error(
  req: HttpRequest<unknown>, next: HttpHandlerFn,
  authService: AuthService,
  authTokenService: AuthTokenService,
  logger: LoggerService,
  router: Router) {
  if (!isRefreshing) {
    isRefreshing = true;
    authTokenService.tokenRefresh = null;
    // refreshTokenSubject$.next(null);

    return authService.refreshToken()
      .pipe(
        switchMap((newToken: any) => {
          logger.debug(`switchMap:newToken: `, newToken);
          const { meToken, accessToken,
            refreshToken
          } = newToken.token;

          authTokenService.setToken(newToken.token);
          isRefreshing = false;
          // refreshTokenSubject$.next(newToken);  // Release the queued requests
          return next(injectToken(req, meToken))
        }),
        catchError((err) => {
          isRefreshing = false;
          logger.error(`refreshToken:error:`, err);
          authTokenService.removeToken();
          router.navigateByUrl('/login');
          return next(req);
        })
      );
  } else {
    return authTokenService.tokenUser$
      .pipe(
        filter(token => token !== null), //Wait until token is no longer null
        take(1),  //Complete the stream once token arrive
        switchMap((token: string) => next(injectToken(req, token!)))
      )
  }
}

function injectToken(request: HttpRequest<unknown>, token: string) {
  return request.clone({
    withCredentials: true,
    headers: request.headers.append('Authorization', `Bearer ${token}`),
    // setHeaders: {
    //   Authorization: `Bearer ${token}`
    // }
  })
}
